import { defineMessage } from 'services/localization';

export const messages = {
    passwordValidationTextLength: defineMessage('use_or_more_characters'),
    passwordValidationTextUseNumber: defineMessage('use_a_number_eg'),
    passwordValidationTextUseUpperLowerCase: defineMessage('upper_and_lower_case_letters_eg_aa'),
    passwordValidationTextUseSymbol: defineMessage('use_a_symbol_eg'),
};
